import React from 'react';
import MediaQuery from 'react-responsive';
import { NavLink } from 'react-router-dom';
import { Breadcrumbs } from 'react-breadcrumbs-dynamic';

import './BreadcrumbComponent.scss';

export class BreadcrumbComponent extends React.Component {
    render() {
        return (
            <MediaQuery query="(min-width: 768px)">
                {matches =>
                    matches ? (
                        <Breadcrumbs
                            container="div"
                            containerProps={{ id: 'breadcrumb', className: 'conteneur' }}
                            separator={<span className="separator">></span>}
                            item={NavLink}
                            finalItem="span"
                        />
                    ) : (
                        <div style={{ marginTop: '40px' }} />
                    )
                }
            </MediaQuery>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/breadcrumb/BreadcrumbComponent.js